import { defineMessages } from 'react-intl';

export default defineMessages({
    claimDetails: {
        id: 'quoteandbind.ho.views.ho-risk-analysis.Claim Details',
        defaultMessage: 'Claim Details',
    },  
    lossDate: {
        id: 'quoteandbind.ho.views.ho-risk-analysis.Loss Date',
        defaultMessage: 'Loss Date',
    },
    lossLocation: {
        id: 'quoteandbind.ho.views.ho-risk-analysis.Loss Location',
        defaultMessage: 'Loss Location',
    },
    lossAmount: {
        id: 'quoteandbind.ho.views.ho-risk-analysis.Loss Amount',
        defaultMessage: 'Loss Amount',
    },
    comments: {
        id: 'quoteandbind.ho.views.ho-risk-analysis.Comments',
        defaultMessage: 'Comments',
    },
    
    claimDetailsForThisHome: {
        id: 'quoteandbind.ho.views.ho-risk-analysis.Claim Details for This Home',
        defaultMessage: 'Claim Details for This Home'
    },
    anotherClaimDetails: {
        id: 'quoteandbind.views.ho-risk-analysis.Add Another Claim Details?',
        defaultMessage: 'Add Another Claim Details?'
    },
    addClaimDetails: {
        id:'quoteandbind.views.ho-risk-analysis.Add Claim Details',
        defaultMessage:'Add Claim Details'
    },
    chargeable: {
        id:'quoteandbind.views.ho-risk-analysis.Chargeable',
        defaultMessage:'Chargeable'
    },

    claimCount: {
        id: 'quoteandbind.views.ho-risk-analysis.Claim:',
        defaultMessage: 'Claim : { count }'
    },

    removeClaimHeading:{
        id: 'quoteandbind.views.ho-risk-analysis.Remove Claim?',
        defaultMessage: 'Remove Claim?' 
    },
    removeClaimBody:{
        id: 'quoteandbind.views.ho-risk-analysis.Are you sure you want to remove this claim from the list?',
        defaultMessage: 'Are you sure you want to remove this claim from the list?' 
    },
    lossCause : {
        id: "quoteandbind.ho.views.ho-risk-analysis.Loss Cause",
        defaultMessage: "Loss Cause"
    }
});
